module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title",
    attrs: {
      "id": "intro"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘The attack upon Korea makes it plain beyond all doubt that Communism has passed beyond the use of subversion to conquer independent nations and will now use armed invasion and war.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("US President Harry S. Truman"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_1",
      "id": "fnint_1"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At 4 a.m., local time Korea, on 25 June 1950, while Washington was shut for the weekend, Marshal Ch’oe Yong-gŏn, supreme commander of the Korean People’s Army ("), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Glossary#rgloss_17",
      "id": "gloss_17"
    }
  }, [_vm._v("KPA")]), _vm._v("), ordered a coast-to-coast armoured and infantry invasion of South Korea. In the first in a series of titles on battles of the Korean War, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North Korea Invades the South: Across the 38th Parallel, June 1950")]), _vm._v(","), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_2",
      "id": "fnint_2"
    }
  }, [_vm._v("†")])]), _vm._v(" the author looks at the causes and immediate outcome of the North Koreans’ seemingly unstoppable thrust down the peninsula.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Capturing the South Korean capital, Seoul, three days later, the KPA crossed the Han River in force. Clearly caught totally unawares, the understrength US Far East Command in Japan commenced an immediate airlift of combat elements of the US 24th Division into Korea in an attempt to stem the communist flood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The US 25th and 1st Cavalry divisions followed, but the North Korean avalanche, spearheaded by armour and artillery, could not be stalled, pushing the Americans and Republic of Korea forces into a small enclave on the south-eastern tip of the peninsula, their backs to the Sea of Japan. In his second title on battles of the Korean War, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North Korean Onslaught: UN Stand at the Pusan Perimeter, August–September 1950")]), _vm._v(","), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_3",
      "id": "fnint_3"
    }
  }, [_vm._v("‡")])]), _vm._v(" the author follows Lieutenant General Walton Walker’s desperate mobile defence tactics to keep the strategic port of Pusan out of North Korean hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout August, and despite repeated penetrating attacks by five KPA divisions, UN forces hold the Naktong Bulge and the Taegu salient.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Tokyo, UN forces supreme commander, General Douglas MacArthur, was putting the final touches to his high-risk and daring plan of a US X Corps amphibious landing at the North Korean west coast port of Inch’ŏn. The unmitigated 15 September beachhead success represented a dramatic turnaround in the fortunes of war on the peninsula as the UN alliance took the war to the North Koreans for the first time. The author takes a close look at this landmark event in his third title on battles of the Korean War, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Inchon Landing: MacArthur’s Korean War Masterstroke, September 1950")]), _vm._v("."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_4",
      "id": "fnint_4"
    }
  }, [_vm._v("§")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Possibly driven more by the accolades and state-side adulation rather than by tactical advantage, General MacArthur piled enormous pressure on Washington for authorization to pursue the battered remnants of the KPA across the 38th Parallel and into North Korea. South Korean president Syngman Rhee needed no such approval, and on 30 September unleashed his troops north along the North Korean eastern seaboard in a remarkably swift march on the port city of Wŏnsan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Almost two weeks later, President Truman gave his executive consent and the US 1st Cavalry Division led the US Eighth Army, with British and Australian attachments, into North Korea, striking for the capital P’yŏngyang. This phase of the Korean War is covered by the author in his fourth title in the series on the conflict: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Korean War: Allied Surge, Pyongyang Falls, UN Sweep to the Yalu")]), _vm._v("."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_5",
      "id": "fnint_5"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 12 October, three days after the publicity exercise between Truman and MacArthur on Wake Island, the US Central Intelligence Agency ("), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Glossary#rgloss_2",
      "id": "gloss_2"
    }
  }, [_vm._v("CIA")]), _vm._v(") made what may be argued as its most official report to the White House on the subject of foreign intervention in Korea:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "quote"
  }, [_vm._v("The Chinese Communist ground forces, currently lacking requisite air and naval support, are capable of intervening effectively, but not necessarily decisively, in the Korean conflict. There are no convincing indications of an actual Chinese Communist intention to resort to full-scale intervention in Korea. After reviewing the factors favoring, and those opposing, Chinese Communist intervention, it is concluded that while full-scale Chinese Communist intervention in Korea must be regarded as a continuing possibility, a consideration of all known factors leads to the conclusion that barring a Soviet decision for global war, such action is not probable in 1950. During this period, intervention will probably be confined to continued covert assistance to the North Koreans."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_6",
      "id": "fnint_6"
    }
  }, [_vm._v("†")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Chinese or Soviet forces did not intervene at Inch’ŏn, at the crossing of the 38th Parallel or when UN forces reached the Yalu, the CIA appeared to adopt the assumption that they would not do so at all. The repeated failure to recognize such a possibility would to some extent explain the CIA’s insistent assumption in the estimates that the Chinese could not take a decisive part in the war without inevitably pushing themselves and the Soviet Union into a world war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With Mao Zedong’s communist victory over Chiang Kai-shek’s Kuomintang forces at the close of 1949,"), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_7",
      "id": "fnint_7"
    }
  }, [_vm._v("‡")])]), _vm._v(" the Communist Chinese had around two million men under arms, with another two million reservists. Whilst many of these troops were concentrated along the Korean border, during 1950 Mao’s armies had also reached the area opposite Taiwan\n"), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("\nand moved south to the borders of Hong Kong, Indochina and Burma. It was, therefore, perceived by the CIA that all these areas were faced with a new threat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the outbreak of the Korean War was interpreted by the CIA as strictly a move by Moscow in terms of world strategy. The known fact that the P’yŏngyang regime existed only by virtue of Soviet support, and was totally subservient to Soviet influence, gave full credibility to the CIA estimates at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Washington’s greatest concern, underpinned by Communist Chinese propaganda out of Beijing and proximate dispositions of the People’s Liberation Army ("), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Glossary#rgloss_20",
      "id": "gloss_20"
    }
  }, [_vm._v("PLA")]), _vm._v("), remained as threats to Nationalist Chinese Taiwan and Japan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The CIA director’s memorandum to President Truman of 1 November now conceded that up to 20,000 Chinese troops had in fact been operating south of the Yalu River, ‘organized in task force units … while the parent units remain in Manchuria’."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_8",
      "id": "fnint_8"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even then, the memo contended, and in agreement with Chinese propaganda, that the presence in North Korea was to protect the Suiho Hydroelectric Zone on the Yalu from hostile actions, referring to it as a ‘limited cordon sanitaire’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nearly a week after actual intervention, the CIA, albeit still with some reservation, concurred that the Chinese People’s Volunteer Army ("), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Glossary#rgloss_3",
      "id": "gloss_3"
    }
  }, [_vm._v("CPVA")]), _vm._v(") had the capability of halting further UN advances northward ‘through piecemeal commitment of troops’ or force ‘UN withdrawal to defensive positions farther south by a powerful assault’."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_9",
      "id": "fnint_9"
    }
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From early November, US Far East Air Force ("), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Glossary#rgloss_7",
      "id": "gloss_7"
    }
  }, [_vm._v("FEAF")]), _vm._v(") B-29 and B-26 bombers commenced a fortnight of saturation bombing of the North Korean border buffer zone with Manchuria, to ‘destroy every means of communication and every installation, factory, city, and village’."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_10",
      "id": "fnint_10"
    }
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("General MacArthur’s scorched-earth campaign, which included the use of incendiaries for the first time in the conflict, caused near total destruction of many towns and supply centres in the designated target area. In related operations, bridges over the Yalu River were also bombed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aerial reconnaissance was restricted to the limited resources of the 543rd Tactical Support Group, but neither the air force nor the US Eighth Army had sufficient skilled photographic interpreters to examine and draw conclusions from the piles of images taken in the proximity of Yalu River crossings. With only a few aircraft, the US 8th Squadron confined their aerial observations to the roads leading from the Yalu to the US Eighth Army and US X Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, on 21 November, the US Fifth Air Force was ordered to conduct close aerial reconnaissance of the area between the two UN forces. But by this time, preparations to strike north were in an advanced stage.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Harry S. Truman. (Photo NARA)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Mao Zedong")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Kim Il-sung. (Photo Karow)")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Joseph Stalin.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 24 November, two days before the launch of the CPVA’s first offensive, the CIA estimated that combined Chinese and North Korean forces were incapable of driving the UN off the peninsula, but had the strength to force the international alliance to defensive positions for ‘prolonged and inconclusive operations, such, the Communists might calculate, would lead to eventual withdrawal from Korea’."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#rfnint_11",
      "id": "fnint_11"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Washington’s miscalculations of China’s intentions became rudely and painfully evident on 26 November when General Lin Biao’s ‘volunteers’, in North Korea since mid-October, fell on the US I and IX corps, while simultaneously jumping off from Tŏkch’ŏn to plough through the Republic of Korea Army ("), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Glossary#rgloss_25",
      "id": "gloss_25"
    }
  }, [_vm._v("ROKA")]), _vm._v(") II Corps. The following two months witnessed the longest retreat in the history of the American military.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of November, US President Truman publicly announced that the use of the atomic bomb was under consideration to check the Red tide. At the same time, the US Strategic Air Command was placed on alert for an immediate deployment of medium bombers to the Far East. Should they go, it would be with atomic capabilities, or what the Pentagon liked to refer to as ‘weapons of mass destruction’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Through to March 1951, the CPVA launched successive offensives, all the while augmenting the troops in Korea with six armies drawn from the First and Second PLA field armies. The US Eighth Army was forced to withdraw south of the Ch’ŏngch’ŏn River as the US 2nd and 25th infantry divisions faced envelopment and annihilation by eighteen CPVA divisions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the Changjin Reservoir, known as Chosin Reservoir on Japanese maps, the US 1st Marine and US 3rd and 7th infantry divisions, and 41 Royal Marine Commando, desperately fought for survival against the CPVA IX and XIII corps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In quick succession, the UN forces evacuated the North Korea capital P’yŏngyang and the east coast port of Hŭngnam. On 16 December, President Truman declared a national state of emergency. Two weeks later, the communists regained Seoul and the UN Command abandoned Inch’ŏn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("General MacArthur’s forces fell back on the 38th Parallel. In three months, the euphoric successes of the bold Inch’ŏn amphibious landing, the breakout from the Pusan Perimeter and the lightning speed with which his troops had reached the Manchurian border at the Yalu River, suddenly meant for nothing. Overwhelmingly superior numbers of Chinese troops, driven by a seemingly crazed Mao-indoctrinated fervour, threatened to clear the whole Korean Peninsula of all UN troops and forcibly unite north and south.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A year after the "), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Glossary#rgloss_22",
      "id": "gloss_22"
    }
  }, [_vm._v("People’s Republic of China")]), _vm._v(" declared its existence, its forces were ploughing through North Korea to drive the United Nations forces off the Yalu River. General Peng Dehuai was entrusted with saving Kim Il-sung’s regime as a matter of grand strategy: holding Korea would secure Manchuria. Kim with thousands of Koreans had\n"), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("\nfought hand in hand with the People’s Volunteer Army (PVA) in 1949: now it was China’s opportunity to reciprocate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The CPVA’s participation in the Korean War was the first and only conflict when Chinese and American-led forces clashed in conventional warfare. Initially, the CPVA, drawn from the PLA, enjoyed the advantage provided by its seasoned commanders, whose combat experience and discipline were very evident. With the stalemate at the 38th Parallel, the PVA’s shortcomings became visible, especially when confronted with American determination and superior air support. The indecisive Korean conflict, halted with an indeterminate ceasefire in Panmunjom, would cost the PVA a million soldiers.")]), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_1",
      "id": "rfnint_1"
    }
  }, [_vm._v("*")])]), _vm._v(" UN Command, Military Intelligence Section, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Korea, A Summary 25 June 1950–25 April 1952")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_2",
      "id": "rfnint_2"
    }
  }, [_vm._v("†")])]), _vm._v(" Pen and Sword Books, Barnsley, 2018.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_3",
      "id": "rfnint_3"
    }
  }, [_vm._v("‡")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_4",
      "id": "rfnint_4"
    }
  }, [_vm._v("§")])]), _vm._v(" Pen and Sword Books, Barnsley, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_5",
      "id": "rfnint_5"
    }
  }, [_vm._v("*")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_6",
      "id": "rfnint_6"
    }
  }, [_vm._v("†")])]), _vm._v(" CIA Historical Staff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Study of CIA Reporting on Chinese Communist Intervention in the Korean War, September–December 1950")]), _vm._v(" (October 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_7",
      "id": "rfnint_7"
    }
  }, [_vm._v("‡")])]), _vm._v(" Gerry van Tonder, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Red China: Mao Crushes Chiang’s Kuomintang, 1949")]), _vm._v(" (Pen and Sword Books, Barnsley, 2018")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_8",
      "id": "rfnint_8"
    }
  }, [_vm._v("*")])]), _vm._v(" CIA Historical Staff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Study of CIA Reporting on Chinese Communist Intervention in the Korean War, September–December 1950")]), _vm._v(" (October 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_9",
      "id": "rfnint_9"
    }
  }, [_vm._v("†")])]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_10",
      "id": "rfnint_10"
    }
  }, [_vm._v("‡")])]), _vm._v(" Robert Frank Futrell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The United States Air Force in Korea, 1950–1953")]), _vm._v(" (Progressive Management, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_hang"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#fnint_11",
      "id": "rfnint_11"
    }
  }, [_vm._v("*")])]), _vm._v(" CIA Historical Staff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Study of CIA Reporting on Chinese Communist Intervention in the Korean War, September–December 1950")]), _vm._v(" (October 1955).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebd71e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Introduction.vue
// module id = 72
// module chunks = 0